import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../pages/main-layouts/MainLayout";
import Login from "../pages/auth/Login";
import ManageCategory from "../pages/main-layouts/manage-category/ManageCategory";
import ManageCourses from "../pages/main-layouts/manage-courses/ManageCourses";
import Faq from "../pages/main-layouts/manage-faqs/Faq";
import LandingPage from "../pages/main-layouts/manage-landingpage/LandingPage";
import ManageLibrary from "../pages/main-layouts/manage-library/ManageLibrary";
import VoucherRequest from "../pages/review-layouts/voucher-request/VoucherRequest";
import ManageAdmin from "../pages/main-layouts/manage-admin/ManageAdmin";
import ManageCode from "../pages/main-layouts/manage-codes/ManageCode";
import Reports from "../pages/reports-layouts/Reports";

interface AppRoutesProps {
  isAuthenticated: boolean;
  setIsAuthenticated: (auth: boolean) => void;
}

// Protected Route wrapper
const ProtectedRoute: React.FC<{
  isAuthenticated: boolean;
  children: React.ReactNode;
}> = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

const AppRoutes: React.FC<AppRoutesProps> = ({
  isAuthenticated,
  setIsAuthenticated,
}) => (
  <Routes>
    <Route path="/" element={<Navigate to="/app/manage-category" />} />

    <Route
      path="/login"
      element={
        isAuthenticated ? (
          <Navigate to="/app/manage-category" replace />
        ) : (
          <Login setIsAuthenticated={setIsAuthenticated} />
        )
      }
    />

    <Route
      path="/app"
      element={
        <ProtectedRoute isAuthenticated={isAuthenticated}>
          <MainLayout setIsAuthenticated={setIsAuthenticated} />
        </ProtectedRoute>
      }
    >
      <Route path="manage-category" element={<ManageCategory />} />
      <Route path="manage-courses" element={<ManageCourses />} />
      <Route path="manage-faqs" element={<Faq />} />
      <Route path="manage-landingpage" element={<LandingPage />} />
      <Route path="manage-libraries" element={<ManageLibrary />} />
      <Route path="manage-admins" element={<ManageAdmin />} />
      <Route path="manage-codes" element={<ManageCode />} />
      <Route path="review-voucher-requests" element={<VoucherRequest />} />
      <Route path="reports" element={<Reports />} />

      {/* More secured routes */}
    </Route>

    <Route path="*" element={<Navigate to="/" />} />
  </Routes>
);

export default AppRoutes;
